import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const VisualizadorPrecio = ({ precioLista, porcentajeDescuentoFullCatalogo }) => {

  return (
    <div className='visualizadorPrecio'>
      <span className={`precioLista ${porcentajeDescuentoFullCatalogo ? 'precioTachado' : ''}`}>${precioLista.toFixed(2)}</span>
      {(porcentajeDescuentoFullCatalogo && porcentajeDescuentoFullCatalogo > 0) ? <span className='precioLista descuento'>${(precioLista-precioLista*porcentajeDescuentoFullCatalogo/100).toFixed(2)}</span> : <span></span>}
    </div>
  );
};

VisualizadorPrecio.defaultProps = {
  precioLista: 0,
  precioPromocional: undefined,
};

VisualizadorPrecio.propTypes = {
  precioLista: PropTypes.number,
  precioPromocional: PropTypes.number,
};

export default VisualizadorPrecio;
